module.exports = __webpack_public_path__ + "img/bg_planet_fiber.80e8203d.png";